// extracted by mini-css-extract-plugin
module.exports = {"duoIconBackground":"#76bb59","jcGrey100":"#f1f3f4","duo":"ChooseMfa__duo","push":"ChooseMfa__push","totp":"ChooseMfa__totp","webauthn":"ChooseMfa__webauthn"};